import serviceProviderStore from '@/stores/service-provider-store.js'
import axios from 'axios'

export default function getAuthConfig() {
  let spSlug
  if (window.location.host == 'lockery.discovery.com') {
    spSlug = 'tvn'
  } else {
    spSlug = window.location.host.split('.')[0]
    //  FOR TESTING ON DEV ONLY!!! >>
    // spSlug = 'efl'
    // spSlug = 'collectomate'
    //  << FOR TESTING ON DEV ONLY!!!
  }
  serviceProviderStore.commit('setSlug', spSlug)
  return axios({
    method: 'get',
    url: 'service_providers/get_auth_details',
    params: {
      slug: spSlug,
    },
  }).then(response => {
    if (response.status === 200) {
      serviceProviderStore.commit('setAuthMethods', response.data.authMethods)
      serviceProviderStore.commit('setOktaDomain', response.data.oktaDomain)
      serviceProviderStore.commit('setOktaClientId', response.data.oktaClientId)
      serviceProviderStore.commit('setOktaIssuer', response.data.oktaIssuer)
      serviceProviderStore.commit('setId', response.data.id)
    } else {
      console.log("Can't get auth details")
    }
  })
}
